import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function TestimonialsSection() {
  return <section className="w-full bg-cream-100 px-6 pb-10 sm:pb-12" aria-labelledby="testimonials-title" data-id="element-167" data-mp="1n0aifuwodh2y">
      <div className="mx-auto max-w-4xl" data-id="element-168" data-mp="1r1422c3349q1">
        <SectionHeading id="testimonials-title" badge="Testimonials" badgeIcon={StarIcon} title="What Other Instructors Are Saying" data-id="element-169" data-mp="1r02oo0yljb55" />

        <ul className="mt-6 grid gap-3.5 md:grid-cols-2" data-id="element-170" data-mp="1i1qszkivhn5u">
          {testimonials.map(({
          quote,
          initials,
          name,
          role
        }) => <li key={name} className="flex h-full flex-col rounded-2xl border border-cream-300/60 bg-white p-6" data-id="element-171" data-mp="143995xw38ut7">
              <span className="flex gap-0.5" aria-label="Rated 5 out of 5" data-id="element-172" data-mp="2yexrma1j3fic">
                {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-3.5 w-3.5 fill-ember-400 text-ember-400" aria-hidden="true" data-id="element-173" data-mp="32g989q2fcqee" />)}
              </span>
              <blockquote className="mt-4 text-[0.95rem] leading-relaxed text-forest-600/90" data-id="element-174" data-mp="2q2rbko0oy4rw">
                “{quote}”
              </blockquote>
              <div className="mt-auto flex items-center gap-3 pt-6" data-id="element-175" data-mp="34quji2yanqjc">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-forest-600 text-xs font-bold text-cream-50" data-id="element-176" data-mp="2zs1424zg5pgj">
                  {initials}
                </span>
                <div data-id="element-177" data-mp="2745a3819ibng">
                  <p className="text-sm font-semibold text-forest-800" data-id="element-178" data-mp="274ot6s2nf632">{name}</p>
                  <p className="text-xs text-forest-700/85" data-id="element-179" data-mp="2m1fmqkpn5nkr">{role}</p>
                </div>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}